import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChartLine = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-chart-line-icon lucide-chart-line",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M3 3v16a2 2 0 0 0 2 2h16" }), /* @__PURE__ */ _jsx("path", { d: "m19 9-5 5-4-4-3 3" })]
});
export default SvgChartLine;
